import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IScanHistoryWidgetProps {
    onClose: () => void;
}

export const ScanHistoryWidget = ({ onClose }: IScanHistoryWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt;
                    <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_view_my_scan_history"
                        defaultMessage="How do I view my scan history"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-12">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="Go_to_the_quote"
                                    defaultMessage=" Step 1. Go to the '"
                                />
                                <a href="/my-account/hearing-aid-history">
                                    <FormattedMessage
                                        id="Device_History"
                                        defaultMessage="Device History"
                                    />
                                </a>
                                <FormattedMessage
                                    id="page_quote"
                                    defaultMessage="' page"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Enter_patient_last_name_or_serial"
                                    defaultMessage="Step 2. Enter patient last name or serial number for the device"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Scroll_down_and_view_your_Scan_History"
                                    defaultMessage="Step 3. Scroll down and view your Scan Historyy"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="If_there_is_no_ID_or_Date"
                                    defaultMessage="Step 4. If there is no ID or Date in the scan history
                                row, we do not have a scan on file"
                                />{' '}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const scanHistoryWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScanHistoryWidget);

export default scanHistoryWidgetContainer;
